// The hallway board of a shared house (golf 6b): plain and adult, readable from 2 to 3 metres.
export const hallwayEn = {
    thisWeek: 'Whose turn this week',
    today: 'Today',
    cooks: '{name} cooks',
    nobody: 'Nobody',
    done: 'Done',
    doneBy: 'Done by {name}',
    tapHint: 'Tap a chore when it is done',
    whoDid: 'Who did {duty}?',
    saved: '{duty}: done by {name}',
    undo: 'Oops, undo',
    undone: 'Undone',
    agenda: 'House calendar',
    nothingPlanned: 'Nothing planned',
    close: 'Close',
    allDone: 'All done this week',
    noDuties: 'No rota yet. Create it in the app under Chore rota.',
};
//# sourceMappingURL=hallway.en.js.map